import {LIMPAR_ULTIMOS_HISTORICOS_ITINERARIO} from '../types';

export default function limparUltimosHistoricosItinerario () {
    return {
        type: LIMPAR_ULTIMOS_HISTORICOS_ITINERARIO
    }
}
